/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'instruments/monitor': {
    width: 16,
    height: 16,
    viewBox: '0 0 480 480',
    data: '<path pid="0" d="M456 64H24C10.745 64 0 74.745 0 88v256c0 13.255 10.745 24 24 24h137.056l-21.336 32H96a8 8 0 000 16h288a8 8 0 000-16h-43.72l-21.336-32H456c13.255 0 24-10.745 24-24V88c0-13.255-10.745-24-24-24zM321.048 400H158.952l21.328-32h119.44l21.328 32zM464 344a8 8 0 01-8 8H24a8 8 0 01-8-8V88a8 8 0 018-8h432a8 8 0 018 8v256z"/><path pid="1" d="M24 88v256h432V88H24zm416 240H40V104h400v224z"/>'
  }
})
